import React from 'react';
import PropTypes from 'prop-types';

import { Carousel as CarouselRRC } from 'react-responsive-carousel';
// import './carousel.scss';

const Carousel = ({ children, ...props }) => <CarouselRRC {...props} preventMovementUntilSwipeScrollTolerance
swipeScrollTolerance={100} >{children}</CarouselRRC>;

Carousel.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Carousel;
